import cx from 'classnames'
import {noop} from 'lodash'
import styles from './styles.module.css'

type Props = {
  checked?: boolean
  disabled?: boolean
  name: string
  value?: string
  onChange?: (checked: boolean) => void
  className?: string
  id?: string
}

export const CheckboxInput = ({checked, name, disabled, onChange = noop, className, id, value}: Props) => {
  return (
    <input
      id={id}
      type="checkbox"
      name={name}
      value={value}
      className={cx(styles.checkbox, className)}
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
  )
}
